<ng-container
  *ngLet="{
    days: days | async,
    dateStats: dateStats | async,
    selectedParts: selectedParts | async,
    today: today | async,
    label: label | async
  } as vm"
>
  <div class="rv-flex rv-button-set small">
    <select-dropdown
      [disabled]="disabled"
      [options]="monthOptions"
      class="rv-grow"
      [selectedOptionId]="vm.selectedParts?.month?.toString()"
      (selectedOptionIdChange)="change.next({ type: 'month', value: $event })"
    ></select-dropdown>
    <select-dropdown
      [disabled]="disabled"
      [options]="yearOptions"
      [style.min-width.px]="115"
      [selectedOptionId]="vm.selectedParts?.year?.toString()"
      (selectedOptionIdChange)="change.next({ type: 'year', value: $event })"
    ></select-dropdown>
  </div>
  <div class="day-container">
    <button
      class="day"
      *ngFor="let day of vm.days"
      [class.today]="vm.today.visible && vm.today.date == day.value"
      [class.selected]="!day.disabled && vm.selectedParts.date == day.value"
      [disabled]="day.disabled || disabled"
      (click)="change.next({ type: 'date', value: day.value })"
    >
      {{ vm.label(day.value) }}
    </button>
  </div>
  <div class="rv-flex" *ngIf="!disabled">
    <div class="rv-button-set small">
      <button
        id="date-picker-today"
        rivButton
        [variant]="'basic'"
        [size]="'medium'"
        (click)="change.next({ type: 'today' })"
      >
        {{ 'app.today' | translate }}
      </button>
      <button
        *ngIf="clearable"
        rivButton
        [variant]="'ghost'"
        [size]="'medium'"
        (click)="clearDate.emit()"
      >
        Clear
      </button>
    </div>
    <div class="rv-button-set small">
      <button
        rivButton
        [variant]="'basic'"
        [size]="'medium'"
        (click)="change.next({ type: 'back' })"
        [icon]="'ArrowLeft'"
      ></button>
      <button
        rivButton
        [variant]="'basic'"
        [size]="'medium'"
        (click)="change.next({ type: 'forward' })"
        [icon]="'ArrowRight'"
      ></button>
    </div>
  </div>
</ng-container>
